import React, { useContext } from 'react'
import { customVariableDataInterface } from '../../../../../../models/axiosModel'
import { CombinedUpdateType, combinedValueType } from './variableAssignmentPopup'
import { Autocomplete, AutocompleteRenderInputParams, Grid, Typography } from '@mui/material'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext'
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import Required from '../../../../../utility/required'
import { isCurrentViewVersionPublished } from '../../../utilityFunctions'
import { filterAutocompleteOptionsWithException } from '../../../../../../utils/constants'

interface RenderTargetVariableProps {
    getVariableOptions: () => customVariableDataInterface[]
    chatbot_custom_variable_configuration_id: string,
    checkIfOptionsisDisabled: (chatbot_custom_variable_configuration_id: string, configuration_id: string) => boolean,
    getValueOfFields: (type: combinedValueType) => any,
    onChangeOfFields: ({ type, value }: CombinedUpdateType) => void,
    renderOptions: (props: React.HTMLAttributes<HTMLLIElement>, option: any) => React.ReactNode,
    renderInputForVariableAutoComplete: (params: AutocompleteRenderInputParams, placeholder: string) => JSX.Element,
} 

const RenderTargetVariable: React.FC<RenderTargetVariableProps> = (props) => {
    
    const {getVariableOptions,chatbot_custom_variable_configuration_id , getValueOfFields, onChangeOfFields, renderOptions, renderInputForVariableAutoComplete, checkIfOptionsisDisabled } = props;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload
    
    return (
        <>
            <Grid item xs={12}>
                <Grid container gap={1}>
                    <Grid item xs={12}>
                        <Typography className={styles.createWorkflowLabelStyle}>Target Variable <Required /></Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            className={`${workflowStyles.resetVariableAutoComplete} ${globalStyles.fullwidth}`}
                            options={getVariableOptions()}
                            filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "chatbot_custom_variable_name", "chatbot_custom_variable_configuration_id")}
                            getOptionLabel={(option) => option?.chatbot_custom_variable_name || ""}
                            getOptionDisabled={(option) => checkIfOptionsisDisabled(option?.chatbot_custom_variable_configuration_id, chatbot_custom_variable_configuration_id)}
                            value={getValueOfFields("target variable") as customVariableDataInterface | null}
                            onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => onChangeOfFields({ type: "target variable", value: value })}
                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            ListboxProps={{ className: contactStyles.listBoxCustomStyle }}
                            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: customVariableDataInterface) => { return renderOptions(props, option); }}
                            renderInput={params => renderInputForVariableAutoComplete(params, 'Select Target Variable')}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default RenderTargetVariable
